<div class="bg-primary-500 dark:bg-surface-950">
	<div class="relative">
		<div
			class="overflow-x-auto"
			style="scrollbar-width: none">
			<ul
				#list
				class="p-0 m-0 bg-surface-0 list-none flex select-none relative">
				@for (item of tabs; track item.label; let index = $index) {
				<li class="flex-1 relative">
					<div class="flex flex-row justify-center items-center">
						<a
							class="cursor-pointer py-3 px-2 flex items-center justify-center transition-colors duration-150 hover:text-primary"
							[ngClass]="{
											'text-primary dark:text-primary-400 font-semibold': active === index,
											'text-surface-500 dark:text-surface-400': active !== index,
										}"
							(click)="setActiveTab($event, index)">
							{{ item.label }}
						</a>
						@if (item.hasSupportingInfo) {
						<p-button
							icon="pi pi-question"
							aria-label="Vin Help Info"
							[rounded]="true"
							[outlined]="true"
							size="small"
							[disabled]="active !== index"
							(onClick)="vinHelpIsVisible = true" />
						}
					</div>
					@if (active === index) {
					<span
						class="absolute bottom-0 w-full h-0.5 z-20 bg-rdus-orange-light-400 transition-transform translate-x-[var(--tab-dx)] scale-x-[var(--tab-dw)] duration-300 ease-in-out"></span>
					}
				</li>
				}
			</ul>
		</div>
		<div class="absolute bottom-0 left-0 w-full h-0.5 bg-surface-200 dark:bg-surface-700"></div>
		@if (active === 0) {
		<div class="mt-4 card flex flex-row w-full">
			<p-floatlabel
				variant="in"
				class="mr-2"
				style="width: 50%">
				<input
					id="plate"
					#licensePlateInput
					pInputText
					(focus)="onLicensePlateFocus()"
					(keydown)="preventCharacters($event)"
					[(ngModel)]="licensePlateNumber"
					class="w-full"
					[disabled]="isSubmitting" />
				<label for="plate">License Plate</label>
			</p-floatlabel>

			<p-floatlabel
				variant="in"
				style="width: 50%">
				<p-select
					inputId="state"
					[options]="states"
					[(ngModel)]="selectedState"
					(ngModelChange)="onStateFocus($event)"
					optionLabel="name"
					#stateModel="ngModel"
					[ngClass]="{ 'zip-invalid': isStateInvalid }"
					class="w-full"
					[disabled]="isSubmitting" />
				<label for="state">State</label>
			</p-floatlabel>
		</div>

		<div class="card flex flex-col">
			<p-floatlabel
				variant="in"
				class="my-4">
				<input
					id="zip"
					#zipInput
					pInputText
					(focus)="onZipFocus()"
					[(ngModel)]="zip"
					class="w-full"
					[disabled]="isSubmitting" />
				<label for="zip">Zip Code</label>
			</p-floatlabel>

			<p-button
				id="lp-get-offer-btn"
				fluid
				iconPos="right"
				[dt]="orangeDarkBg"
				label="GET MY OFFER"
				icon="pi pi-arrow-right"
				[loading]="isSubmitting"
				(onClick)="submitOfferForm()" />
		</div>
		} @if (active === 1) {
		<div class="mt-4 card flex-col">
			<p-floatlabel variant="in">
				<input
					id="vin"
					pInputText
					[(ngModel)]="vin"
					class="w-full p-2"
					[disabled]="isSubmitting" />
				<label for="vin">VIN</label>
			</p-floatlabel>

			<p-floatlabel
				variant="in"
				class="my-4">
				<input
					id="vinZip"
					#zipInput
					pInputText
					(focus)="onZipFocus()"
					[(ngModel)]="zip"
					class="w-full"
					[disabled]="isSubmitting" />
				<label for="vinZip">Zip Code</label>
			</p-floatlabel>

			<p-button
				id="vin-get-offer-btn"
				fluid
				iconPos="right"
				[dt]="orangeDarkBg"
				label="GET MY OFFER"
				icon="pi pi-arrow-right"
				[loading]="isSubmitting"
				(onClick)="submitOfferForm()" />

		</div>
		}
	</div>

	<div
		id="errorDiv"
		class="mt-4 p-3"
		#errorDiv>
		<i class="pi pi-exclamation-triangle"></i
		><span
			id="errorMessage"
			#errorMessage
			class="ml-3"></span>
	</div>

	<div class="card">
		<p-dialog
			[(visible)]="vinHelpIsVisible"
			[modal]="true"
			[breakpoints]="{ '960px': '75vw', '640px': '80vw' }"
			[style]="{ width: '40rem' }"
			[showHeader]="false"
			styleClass="shadow-sm !border-0"
			contentStyleClass="p-6!"
			footerStyleClass="pb-6! px-6!"
			maskStyleClass="backdrop-blur-sm">
			<div class="flex flex-col gap-6">
				<div class="flex flex-col items-center gap-4">
					<div
						class="flex items-center justify-center h-12 w-12 bg-primary-100 dark:bg-primary-400/30 rounded-full border border-primary-200 dark:border-primary-400/20 shrink-0">
						<i class="pi pi-question text-xl! leading-none! text-primary-500 dark:text-primary-200"></i>
					</div>
					<h3 class="font-semibold text-xl text-surface-900 dark:text-surface-0 text-center m-0">
						Need help finding your VIN?
					</h3>
				</div>
				<p class="text-base leading-normal text-surface-700 dark:text-surface-300 text-center p-0 m-0">
					You can find your VIN in the following places:
				</p>
				<ul class="list-disc list-inside text-center">
					<li>On your vehicle title or registration</li>
					<li>On a plate or sticker on the driver's side door jamb</li>
					<li>Stamped on your dashboard near the windshield</li>
				</ul>
			</div>
			<ng-template #footer>
				<div class="flex flex-col w-full gap-4 md:flex-row">
					<button
						pButton
						[outlined]="true"
						class="flex-1"
						size="small"
						(click)="vinHelpIsVisible = false">
						<i
							class="pi pi-times"
							pButtonIcon></i>
						<span pButtonLabel>Close</span>
					</button>
				</div>
			</ng-template>
		</p-dialog>
	</div>

	<div class="card">
		<p-dialog
			[(visible)]="defaultNotServiceableDialog"
			[modal]="true"
			[breakpoints]="{ '960px': '75vw', '640px': '80vw' }"
			[style]="{ width: '40rem' }"
			[showHeader]="false"
			styleClass="shadow-sm"
			maskStyleClass="backdrop-blur-sm"
			contentStyleClass="p-6!"
			footerStyleClass="pb-6! px-6!">
			<div class="flex flex-col gap-6">
				<div class="flex flex-col items-center gap-4">
					<div
						class="flex items-center justify-center p-4 bg-yellow-100 dark:bg-primary-400/30 rounded-full border border-yellow-300 dark:border-primary-400/20 shrink-0">
						<i class="pi pi-exclamation-triangle text-yellow-900 dark:text-yellow-100 text-2xl! leading-none!"></i>
					</div>
					<h3 class="font-semibold text-xl text-surface-900 dark:text-surface-0 text-center m-0">
						We're sorry, we need additional information to buy your car.
					</h3>
					<p class="text-base leading-normal text-surface-700 dark:text-surface-300 text-center p-0 m-0">
						Please give us a call today for the best offer.
					</p>
					<app-call-us-button bgColor="light" [fluid]="false" size="large"></app-call-us-button>
				</div>
			</div>
			<ng-template #footer>
				<div class="flex gap-4">
					<button
						pButton
						severity="secondary"
						class="flex-1"
						size="small"
						(click)="defaultNotServiceableDialog = false">
						<i
							class="pi pi-times"
							pButtonIcon></i>
						<span pButtonLabel>Close</span>
					</button>
					<!-- <div class="flex-1">
						<app-call-us-button bgColor="light"></app-call-us-button>
					</div> -->
				</div>
			</ng-template>
		</p-dialog>
	</div>
</div>
